var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Fetches an absolute URL, with additional paramter and request information.
 *
 * @param absolutePath The path to request (without query parameters)
 * @param params The query parameters
 * @param init The additional request data
 */
export function fetchUrl(absolutePath, params, init) {
    var headers = ((init === null || init === void 0 ? void 0 : init.method) == 'POST' || (init === null || init === void 0 ? void 0 : init.method) == 'PATCH') ? {
        'Content-Type': 'application/json'
    } : {};
    var urlParams = new URLSearchParams(params);
    var paramString = urlParams.toString();
    if (paramString.length > 0) {
        paramString = "?".concat(paramString);
    }
    return fetch("".concat(absolutePath).concat(paramString), appendHeaders(headers, init));
}
/**
 * Appends headers to the given RequestInit
 * @param headers The headers to append
 * @param init Existing request information
 * @returns The resulting RequestInit
 */
function appendHeaders(headers, init) {
    if (init == undefined) {
        return {
            headers: headers
        };
    }
    return __assign(__assign({}, init), { headers: __assign(__assign({}, headers), init === null || init === void 0 ? void 0 : init.headers) });
}
/**
 * Checks if the given status number is within [500, 599]
 * @param status The status code
 * @returns If the status is an Internal Server Error
 */
export function isISE(status) {
    return status >= 500 && status < 600;
}
